import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger } from "@/components/ui/select";
import { ChevronUp } from "@roman/shared/components/Icons";
import type { PredictionMarketChoice } from "@roman/shared/types/PredictionMarket";
import { cn } from "@roman/shared/utils";

type SelectChoiceProps = {
  selectedChoice: PredictionMarketChoice | undefined;
  listChoices: PredictionMarketChoice[];
  setSelectedChoice: (choice: PredictionMarketChoice) => void;
  className?: string;
};

export const SelectChoice = ({ selectedChoice, listChoices, setSelectedChoice, className }: SelectChoiceProps) => {
  if (!selectedChoice || listChoices.length === 0) {
    return null;
  }

  const handleValueChange = (value: string) => {
    const choice = listChoices.find((c) => c.id === value);
    if (choice) {
      setSelectedChoice(choice);
    }
  };

  return (
    <Select value={selectedChoice.id} onValueChange={handleValueChange}>
      <SelectTrigger
        className={`w-full border-light-gray rounded-lg text-secondary font-semibold ring-0 focus:ring-0 text-center h-10 focus:border-secondary ${className}`}
        iconClassName="opacity-100 text-secondary w-4 h-4 rotate-180 flex-shrink-0"
        icon={ChevronUp}
      >
        <p className="flex-1 text-[16px] font-bold leading-[140%] text-left text-black truncate min-w-0">
          {selectedChoice.name}
        </p>
      </SelectTrigger>

      <SelectContent
        className="rounded-lg py-[6px] max-h-[345px] w-[var(--radix-select-trigger-width)] max-w-[var(--radix-select-trigger-width)]"
        position="popper"
        style={
          {
            // Force truncate on all text content
            "--select-item-text-overflow": "ellipsis",
            "--select-item-white-space": "nowrap",
            "--select-item-overflow": "hidden",
          } as React.CSSProperties
        }
      >
        <SelectGroup>
          {listChoices.map((choice) => (
            <SelectItem
              key={choice.id}
              value={choice.id}
              className="border-b focus:bg-white focus:text-secondary focus:font-bold rounded-none shadow-none text-base flex justify-between items-center mb-0 pr-0 p-4 mr-0 w-full overflow-hidden [&>span:last-child]:truncate [&>span:last-child]:flex-1 [&>span:last-child]:min-w-0 [&>span:last-child]:overflow-hidden [&>span:last-child>span]:truncate [&>span:last-child>span]:block"
              iconClassName={cn(
                "opacity-0 text-secondary w-5 h-5 rounded-full bg-secondary p-1 flex-shrink-0 order-2",
                choice.id === selectedChoice.id && "opacity-100",
              )}
              style={{
                maxWidth: "var(--radix-select-trigger-width)",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {choice.name}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
